/**
 * @generated SignedSource<<23a29c23a3c4ebcb8695290a1e4bb414>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CharacterSelectQuery$variables = Record<PropertyKey, never>;
export type CharacterSelectQuery$data = {
  readonly characters: ReadonlyArray<{
    readonly accentHex: string;
    readonly artKey: string;
    readonly audience: string;
    readonly displayName: string;
    readonly id: string;
    readonly intensity: number;
    readonly pace: string;
    readonly questionDensity: string;
    readonly slug: string;
  }>;
};
export type CharacterSelectQuery = {
  response: CharacterSelectQuery$data;
  variables: CharacterSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Character",
    "kind": "LinkedField",
    "name": "characters",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "audience",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accentHex",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "artKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "intensity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pace",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "questionDensity",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CharacterSelectQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CharacterSelectQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "cacheID": "036d56f5741c7087744367e4f75f7635",
    "id": null,
    "metadata": {},
    "name": "CharacterSelectQuery",
    "operationKind": "query",
    "text": "query CharacterSelectQuery {\n  characters {\n    id\n    slug\n    displayName\n    audience\n    accentHex\n    artKey\n    intensity\n    pace\n    questionDensity\n  }\n}\n"
  }
};
})();

(node as any).hash = "4bdc7c76336cfa3ad45254c86a98b297";

export default node;
